export default "__VITE_ASSET__CMqUotjx__"